import React from "react";
import { Brain, X } from "lucide-react";
import SessionContextPanel from "./SessionContextPanel";

/**
 * SessionContextDrawer — the session context the copilot carries, in its own
 * overlay.
 *
 * Why it is not a tab in ResultsPanel any more: bugs and cases are *record
 * searches* — they have counts, they are "searched", they arrive in response to
 * an action. Session context is none of those; it exists from the first turn
 * and is always there. Sharing a tab bar with the record searches implied it
 * was a third search, and put its entry point a row below the header while the
 * left pane's Context button sat in the header. It is opened from the header
 * now, level with the left pane's, and gets its own drawer.
 *
 * The shell (overlay, panel, head, body) deliberately reuses the .d5-results-*
 * classes: two drawers opened from the same header must read as one kind of
 * thing. Only the head differs — a title where ResultsPanel has tabs.
 */
const SessionContextDrawer = ({ open, sessionId, ctxTurnKey, ctxResetKey = 0, onClose }) => {
  if (!open) return null;

  return (
    <div className="d5-results-overlay" onClick={onClose}>
      <div
        className="d5-results-panel"
        role="dialog"
        aria-label="Session context"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="d5-results-head">
          <span className="d5-results-title">
            <Brain size={13} strokeWidth={2} />
            Context
          </span>
          <button type="button" className="d5-results-close" title="Close" onClick={onClose}>
            <X size={15} />
          </button>
        </div>

        <div className="d5-results-body d5-results-body-context">
          {/* resetKey, not just turnKey: tse:clear drops the session's
              conversation memory server-side and REUSES the id, so turnKey
              alone cannot tell the panel its contents are gone. Without this
              a "New chat" kept showing the previous investigation's context.
              Carried over from when this panel was a ResultsPanel tab. */}
          <SessionContextPanel
            sessionId={sessionId}
            turnKey={ctxTurnKey}
            resetKey={ctxResetKey}
            active={open}
          />
        </div>
      </div>
    </div>
  );
};

export default SessionContextDrawer;
